<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' :inspectionReport.pkId > 0 ? '编辑' : '新建'"
      width="1200px"
      append-to-body
      top="2vh"
      @close="$reset('form')">
    <el-tabs v-model="defaultTabName" style="height: 700px;">
      <el-tab-pane name="p1" label="基本信息">
        <el-form
            ref="form"
            :model="inspectionReport"
            :rules="ruleValidate"
            :disabled="disabled"
            class="form"
            label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="编号" prop="no">
                <el-input v-model="inspectionReport.no" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="关联单据" prop="billNo">
                <el-input v-model="inspectionReport.billNo" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工序" prop="processName">
                <el-input v-model="inspectionReport.processName" disabled/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="物料编号" prop="materialNo">
                <el-input v-model="inspectionReport.materialNo" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="规格型号" prop="specification">
                <el-input v-model="inspectionReport.specification" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物料名称" prop="materialName">
                <el-input v-model="inspectionReport.materialName" disabled/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <el-form-item label="检验结果" prop="inspectionResult1">
                <el-switch
                    v-model="inspectionReport.inspectionResult1"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="OK"
                    :active-value="true"
                    inactive-text="NG"
                    :inactive-value="false" @change="resultChange"/>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="检验数量" prop="inspectionQuantity">
                <el-input v-model="inspectionReport.inspectionQuantity" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="不良数量" prop="badQuality">
                <el-input v-model="inspectionReport.badQuality"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="备注">
              <el-input v-model="inspectionReport.note" type="textarea" placeholder="请输入"/>
            </el-form-item>
          </el-row>
          <el-row>
            <el-table
                height="420"
                class="childMetrialTable"
                :data="inspectionReport.resultVOS"
                border>
              <el-table-column prop="inspectionCategory" width="60" label="类型"/>
              <el-table-column prop="inspectionItemName" width="100" label="检验名称"/>
              <el-table-column prop="inspectionStandard" label="检验标准"/>
              <el-table-column prop="standardValue" label="标准值">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.standardValue" placeholder="请输入"/>
                </template>
              </el-table-column>
              <el-table-column prop="value1" width="200" label="检验值">
                <template slot-scope="scope">
                  <!--                  <el-select v-if="scope.row.standardValueList.length>0" v-model="scope.row.value1">-->
                  <!--                    <el-option v-for="item in scope.row.standardValueList" :label="item" :value="item" :key="item"/>-->
                  <!--                  </el-select>-->
                  <!--                  <el-input v-else v-model="scope.row.value1" placeholder="请输入"/>-->
                  <el-input v-model="scope.row.value1" placeholder="请输入"/>
                </template>
              </el-table-column>
              <el-table-column prop="inspectionResult" width="130" label="检验结果">
                <template slot-scope="scope">
                  <el-switch
                      v-model="scope.row.inspectionResult"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-text="OK"
                      :active-value="true"
                      inactive-text="NG"
                      :inactive-value="false"
                      @change="singleResultChange"/>
                </template>
              </el-table-column>
              <el-table-column prop="inspectionResultDesc" align="left" label="检验描述" width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.inspectionResultDesc" class="note" type="textarea" placeholder="请输入"/>
                </template>
              </el-table-column>
              <!--          <el-table-column label="操作" align="center" width="80">-->
              <!--            <template slot-scope="scope">-->
              <!--              <el-button type="danger" @click="deleteRow(scope.$index)"> 删除</el-button>-->
              <!--            </template>-->
              <!--          </el-table-column>-->
            </el-table>
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="p2" label="附件">
        <el-form
            ref="form"
            :model="inspectionReport"
            :rules="ruleValidate"
            class="form"
            label-width="80px">
          <el-row>
            <!--        <el-divider/>-->
            <upload-file
                ref="upload" :disabled="disabled"
                :show-file-list="false"
                :auth-index="192"
                style="text-align: right;margin-top: 2px;"
                @upload-success="uploadSuccess"/>
            <el-table :data="inspectionReport.photos" height="100" border>
              <el-table-column prop="photoPath" align="left" label="附件" show-overflow-tooltip>
                <template slot-scope="scope">
                  <!--              <el-input v-model="scope.row.photoPath" class="tabInput"-->
                  <!--                        style="width: 400px; margin: 0 auto; text-align: center"/>-->
                  <span>{{scope.row.photoPath}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="120" class-name="vm-table_operate">
                <template slot-scope="scope">
                  <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
                  <el-button type="danger" @click="inspectionReport.photos.splice(scope.$index, 1)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="p3" label="操作卡">
        <div v-if="inspectionReport.drawFilePath">
          <pdf-preview ref="pdfRead" :pdf-url="url"/>
        </div>
      </el-tab-pane>
    </el-tabs>

    <span v-if="!disabled" slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import constants from "../../../util/constants";
  import UploadFile from "@/components/UploadFile";
  import PdfPreview from "@/components/PdfPreview1";

  export default {
    name: "InspectionReportEdit1",
    components: {UploadFile, PdfPreview},
    data() {
      return {
        constants,
        dialogVisible: false,
        submitLoading: false,
        disabled: false,
        url: "",
        defaultTabName: "p1",
        inspectionReport: {
          pkId: 0,
          no: "",
          billNo: "",
          billType: 50,
          billTypeName: "",
          materialNo: "",
          materialName: "",
          specification: "",
          inspectionQuantity:0,
          badQuality: 0,
          note: "",
          resultVOS: [],
          photos: [],
        },
        ruleValidate: {
          billNo: {required: true, message: "请选择单据", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row, mark, readOnly) {
        this.dialogVisible = true;
        this.disabled = readOnly;
        this.url = "";
        if (row) {
          this.inspectionReport.pkId = row.pkId;
          this.getData();
          this.inspectionReport.drawFilePath = row.drawFilePath;
        } else {
          this.getNode();
        }
        if (this.inspectionReport.drawFilePath) {
          this.loadPdf(this.inspectionReport.drawFilePath);
        }
      },

      // 根据id查询信息
      getData() {
        this.$http.get("basic", `inspectionReports/${this.inspectionReport.pkId}`).then((resp) => {
          if (resp.success) {
            this.inspectionReport = resp.data;
          }
        });
      },
      //加载pdf
      loadPdf(url) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(url)}`).then((res) => {
          // console.log(res);
          if (res.success) {
            this.url = res.data;
          }
        }).catch(() => {
        });
      },
      // 获取编号
      getNode() {
        this.$http.get("basic", "inspectionReports/getNo").then((resp) => {
          if (resp.success) {
            this.inspectionReport.no = resp.data;
          }
        });
      },

      singleResultChange() {
        this.inspectionReport.inspectionResult1 = this.inspectionReport.resultVOS.some((item) => !item.inspectionResult) ? false : true;
      },
      resultChange() {
        this.inspectionReport.resultVOS.forEach((item) => {
          item.inspectionResult = this.inspectionReport.inspectionResult1;
        });
      },
      //选择关联单号
      productionOrderSelect(row) {
        this.inspectionReport.billNo = row.billNo;
        this.inspectionReport.billId = row.pkid;
        this.inspectionReport.specification = row.specification;
        this.inspectionReport.materialName = row.materialName;
        this.inspectionReport.materialNo = row.materialNo;
        this.inspectionReport.materialId = row.materialId;
        this.inspectionReport.checkQuantity = row.quantity;
        this.inspectionReport.badQuality = 0;
        this.inspectionReport.inspectionResult1 = false;

      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            // fileName: fileList[0].name,
            photoPath: fileList[0].key,
          };
          this.inspectionReport.photos.push(params);
        }
      },
      // 下载
      downLoad(row) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.photoPath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },
      // 提交
      submit() {
        if (this.inspectionReport.pkId > 0) {
          this.handleSubmitUpdData();
        } else {
          this.handleSubmitSave();
        }
      },

      // 编辑
      handleSubmitUpdData() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .put("basic", "inspectionReports", this.inspectionReport)
                .then((resp) => {
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },

      // 新建
      handleSubmitSave() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .post("basic", "inspectionReports", this.inspectionReport)
                .then((resp) => {
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },
    },
  };
</script>
